export var CALENDAR_TOGGLE_CONTAINER = 'calendarToggleContainer';
export var CALENDAR_VIEW_TOGGLE_OPTION_MONTH = 'toggleOptionMonth';
export var CALENDAR_VIEW_TOGGLE_OPTION_WEEK = 'toggleOptionWeek';
